import { SupplierMappingTypeEnum, SupplierTypeEnum } from "@gtpl/shared-models/common-models";

export class SupplierCreationDTO{
    supplierType : SupplierMappingTypeEnum;
    supplierId : number;
    userName : string;
    password : string;
  }